import feature from "@/plugins/accountFeatures";

export default function (to, from, next) {
  if (to.meta.featureSlug && feature.enable(to.meta.featureSlug)) {
    next();
    return;
  }
  next({ name: from.name ? from.name : "feed" });
}
